/* eslint-disable */
export default {
  _default: field => `Nilai ${field} tidak valid.`,
  after: (field, [target, inclusion]) =>
    `${field} harus setelah ${inclusion ? 'atau sama dengan ' : ''}${target}.`,
  alpha_dash: field =>
    `${field} hanya boleh berisi karakter alfanumerik, tanda hubung, dan garis bawah.`,
  alpha_num: field => `${field} hanya boleh berisi karakter alfanumerik.`,
  alpha_spaces: field =>
    `${field} hanya boleh berisi karakter alfabet dan spasi.`,
  alpha: field => `${field} hanya boleh berisi karakter alfabet.`,
  before: (field, [target, inclusion]) =>
    `${field} harus sebelum ${inclusion ? 'atau sama dengan ' : ''}${target}.`,
  between: (field, [min, max]) => `${field} harus antara ${min} dan ${max}.`,
  confirmed: field => `Konfirmasi ${field} tidak cocok.`,
  credit_card: field => `${field} tidak valid.`,
  date_between: (field, [min, max]) =>
    `${field} harus antara ${min} dan ${max}.`,
  date_format: (field, [format]) => `${field} harus dalam format ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `${field} harus berupa angka dan boleh mengandung ${
      !decimals || decimals === '*' ? '' : decimals
    } titik desimal.`,
  digits: (field, [length]) =>
    `${field} harus berupa angka dan memiliki ${length} digit.`,
  dimensions: (field, [width, height]) =>
    `${field} harus berukuran ${width} piksel x ${height} piksel.`,
  email: field => `${field} harus berupa email yang valid.`,
  ext: field => `${field} harus berupa file yang valid.`,
  image: field => `${field} harus berupa gambar.`,
  included: field => `${field} harus berupa nilai yang valid.`,
  integer: field => `${field} harus berupa bilangan bulat.`,
  ip: field => `${field} harus berupa alamat IP yang valid.`,
  length: (field, [length, max]) => {
    if (max) {
      return `${field} harus memiliki panjang antara ${length} dan ${max}.`;
    }

    return `${field} harus memiliki panjang ${length}.`;
  },
  max: (field, [length]) =>
    `${field} tidak boleh lebih dari ${length} karakter.`,
  max_value: (field, [max]) => `${field} harus ${max} atau kurang.`,
  mimes: field => `${field} harus memiliki tipe file yang valid.`,
  min: (field, [length]) =>
    `${field} harus memiliki setidaknya ${length} karakter.`,
  min_value: (field, [min]) => `${field} harus ${min} atau lebih.`,
  excluded: field => `${field} harus berupa nilai yang valid.`,
  numeric: field => `${field} hanya boleh berisi karakter numerik.`,
  regex: field => `Format ${field} tidak valid.`,
  required: field => `${field} wajib diisi.`,
  size: (field, [size]) =>
    `Ukuran ${field} harus kurang dari ${formatFileSize(size)}.`,
  url: field => `${field} bukan URL yang valid.`,
  agreement: field => `Harap setujui syarat dan ketentuan sebelum melanjutkan.`,
};
/* eslint-enable */
